import keyMirror from 'react-utils/keyMirror';
export const MODAL_TYPES = keyMirror({
  ASSIGNABLE: null,
  UNASSIGNABLE: null,
  GET_A_CALL: null,
  PHONE_NUMBER_SUBMITTED: null,
  MEETING: null,
  EMAIL: null,
  CALL_US: null
});